import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AssetWrapper {
  readonly markerStart = this.getImagePath('marker-start.png');
  readonly markerGeneric = this.getImagePath('marker-generic.png');
  readonly markerStop = this.getImagePath('marker-stop.png');
  readonly markerStartStop = this.getImagePath('marker-start-stop.png');
  readonly markerCirclePurpleStop = this.getImagePath('circle-purple-stop.png');

  getNumberedMarker(num: number): string {
    const path = `marker-${num}.png`;
    return this.getImagePath(path);
  }

  private getImagePath(path: string): string {
    const fullPath = `assets/imgs/${path}`;
    return fullPath;
  }
}
